import { render, staticRenderFns } from "./InitialChallenge.vue?vue&type=template&id=3862a44e"
import script from "./InitialChallenge.vue?vue&type=script&lang=js"
export * from "./InitialChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports